import React from 'react'

const InsideBnSectionOne = () => {
  return (
    <>
      <div className='container-fluid'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <section id='content'>
                <article>
                  <div>
                    <h3 className=' text-success'>
                      We offer career opportunities that are more than just a
                      job.
                    </h3>
                    <hr />
                    <ul className='list-unstyled'>
                      <li>
                        <h6 className='font-weight-bolder'>YOU’RE VALUED.</h6>
                        Our employees are fundamental to our business. We aim to
                        ensure you always have the tools and resources you need
                        to succeed.{' '}
                      </li>
                      <br />
                      <li>
                        <h6 className='font-weight-bolder'>YOU’RE INVOLVED.</h6>
                        Working in our stores is a great way to connect with the
                        local community.{' '}
                      </li>
                      <br />

                      <li>
                        <h6 className='font-weight-bolder'>
                          YOU’RE A PART OF A TEAM.
                        </h6>
                        We foster a collaborative environment, so that our
                        employees are passionate about their jobs and the
                        company.{' '}
                      </li>

                      <br />

                      <li>
                        <h6 className='font-weight-bolder'>
                          YOU HAVE OPPORTUNITIES.
                        </h6>
                        Once on-board, many of us move within the organization,
                        transitioning through multiple areas of our business.{' '}
                      </li>
                      <br />

                      <li>
                        <h6 className='font-weight-bolder'>
                          YOU MAKE AN IMPACT.
                        </h6>
                        Many on our team enjoy long careers with us and have a
                        real influence on our business.{' '}
                      </li>
                      <br />

                      <li>
                        <h6 className='font-weight-bolder'>
                          YOU’RE ENCOURAGED.
                        </h6>
                        We offer a supportive environment, where you can lean
                        into challenges, while continuously learning.{' '}
                      </li>
                    </ul>
                  </div>
                  <div> </div>
                </article>
              </section>
            </div>
          </div>
        </div>
      </div>

      <br />
      <br />
    </>
  )
}

export default InsideBnSectionOne
